import styled from 'styled-components'

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  @media(max-width: 1050px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media(max-width: 680px) { grid-template-columns: 1fr; }
`

export const Card = styled.article`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 280px;
  padding: 24px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 18px;
  background: ${p => p.theme.palette.colors.surfaceElevated};
  box-shadow: 0 14px 34px ${p => p.theme.palette.colors.shadowStrong};

  > div:last-child { margin-top: auto; }
`

export const Meta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: ${p => p.theme.palette.blue.main};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
`

export const IssuedBadge = styled.strong`
  padding: 5px 9px;
  border-radius: 999px;
  background: ${p => p.theme.palette.colors.successMuted};
  color: ${p => p.theme.palette.success.main};
  font-size: 11px;
  letter-spacing: 0;
  text-transform: none;
`

export const Title = styled.h2`
  margin: 0;
  color: ${p => p.theme.palette.colors.text};
  font-family: Gilroy;
  font-size: 24px;
`

export const Training = styled.p`
  margin: 0;
  color: ${p => p.theme.palette.colors.text};
  font-family: Lato;
`

export const DateText = styled.p`
  margin: 0 0 14px;
  color: ${p => p.theme.palette.colors.muted};
  font-size: 14px;
`
